/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class UpdateIdpGroupRequest {
  /**
  * List of role IDs to assign to this IDP group. This replaces all existing role assignments. 
  */
  'roleIds': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "roleIds",
      "baseName": "roleIds",
      "type": "Array<string>",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return UpdateIdpGroupRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

